import {Divider} from '@wix/wix-ui-tpa/cssVars'
import {useEnvironment} from '@wix/yoshi-flow-editor'
import React, {PropsWithChildren} from 'react'
import {classes} from './filter-container.st.css'

export const FilterContainer = ({children}: PropsWithChildren) => {
  const {isMobile} = useEnvironment()

  return (
    <div className={isMobile ? classes.container : classes.desktopContainer}>
      {children}
      {isMobile ? <Divider className={classes.divider} ariaHidden /> : null}
    </div>
  )
}
